import en from './strings.en';

const ru = {
    lockTooltip: 'Изменение периода доступно после оплаты доступа',
    title: 'Показать за период',
    period: {
        minutes: {
            short: '10 м.',
            full: '10 минут'
        },
        hour: {
            short: '1 ч.',
            full: '1 час'
        },
        day: {
            short: '1 д.',
            full: '1 день'
        },
        week: {
            short: '1 нед.',
            full: '1 неделю'
        },
        month: {
            short: '1 мес.',
            full: '1 месяц'
        },
        quarter: {
            short: '3 мес.',
            full: '3 месяца'
        },
        halfYear: {
            short: '6 мес.',
            full: '6 месяцев'
        },
        year: {
            short: '1 г.',
            full: '1 год'
        }
    }
};

export default { ru, en: { ...ru, ...en} };
